import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

export const sellSheetOpenAtom = atomFamily((productSizeId: number) =>
  atom(false)
);
